import "./v2-question-surface.css";

export default function HelperLine({ id, children }) {
  return (
    <p className="tgc-v2-helper-line" id={id}>
      {children}
    </p>
  );
}
